@if(field){
<div [formGroup]="form" [ngClass]="field.fieldCriteriaConfig? 'criteria-field-container': ''">
  @if(field.fieldCriteriaConfig){
  <div class="field-criteria">
    <mat-select [(value)]="field['fieldCriteriaConfig']['value']" name="operator" hideSingleSelectionIndicator>
      @for(opt of field['fieldCriteriaConfig']['operators']; track $index){
      <mat-option [value]="opt['value']">{{opt['label']}}</mat-option>
      }
    </mat-select>
  </div>
  }
  <div class="field-input-container">
     <mat-form-field class="dynamic-mat-form-field" appearance="outline">
      <mat-label>{{field.camelCase ? field["displayName"] :( field["displayName"] | camelCase)}}</mat-label>
      <input [id]="field['fieldName']" matInput (keyup)="onTextChange(field['fieldName'], $event)" (keypress)="onKeypress($event)"
        (keydown.enter)="onActionTrigger($event, 'enter')"
        (blur)="onActionTrigger($event, 'blur')"
        [attr.maxlength]="field.max" (paste)="onPasteRestriction($event)" [formControlName]="field['fieldName']"
        type="text" [value]="field.selectedValue" />
      @if(field['fieldActionConfig']){
      <span matSuffix class="text-search-suffix-actions">
        @if(showResetSuffix()){
        <mat-icon onKeyDown="" class="suffix-action-icon" title="Reset"
          [class.suffix-action-icon--disabled]="isCurrentFieldDisabled()"
          [attr.aria-disabled]="isCurrentFieldDisabled()"
          (click)="onResetSuffixClick()">clear</mat-icon>
        }
        @if(showFieldActionSearch()){
        <mat-icon onKeyDown="" class="suffix-action-icon" title="Search"
          [class.suffix-action-icon--disabled]="isCurrentFieldDisabled()"
          [attr.aria-disabled]="isCurrentFieldDisabled()"
          (click)="iconClick(field)">{{field['fieldActionConfig']['icon']}}</mat-icon>
        }
      </span>
      }
      @if(form.get(field['fieldName'])?.hasError('required')&& form.get(field['fieldName'])?.touched){
      <mat-error> {{field.displayName | camelCase}} is required</mat-error>
      }
      @if(form.get(field['fieldName'])?.hasError('email')&& form.get(field['fieldName'])?.touched){
      <mat-error> Please enter valid {{field.displayName | camelCase}} </mat-error>
      }
      @if(form.get(field['fieldName'])?.hasError('customError')&& form.get(field['fieldName'])?.touched){
      <mat-error> {{form.get(field['fieldName'])?.errors?.['msg'] | camelCase}} </mat-error>
      }
    </mat-form-field>
  </div>
      @if(field['fieldInfo'] && field['fieldInfo'].length>0){
       @for(info of field['fieldInfo']; track idx; let idx = $index){
        <span class="field-info">{{info}}</span>
       }
    }
</div>
}